import { useRef, useState } from 'react';
import { Paper, Tabs, Tab } from '@mui/material';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import TotalCost from './TotalCost/TotalCost';
import HighestCostMembers from '../DashboardPages/HighestCostMembers/HighestCostMembers';

const CostOverview = () => {
    const ref = useRef(null);
    const [costSummaryTab, setCostSummaryTab] = useState(1);

    const handleAlertsTabChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        setCostSummaryTab(newValue);
    };

    return (
        <Grid size={{ xs: 12, lg: 6 }}>
            <Paper className="smartdashboard-widget" elevation={5} sx={{ height: 'calc(100vh - 140px)', maxHeight: '650px', display: 'flex', flexDirection: 'column', overflow: 'auto' }}>
                <Grid container spacing={2} paddingLeft={2} paddingRight={2}>
                    <Grid size={12} textAlign="center">
                        <Typography display={'inline-block'} variant="h6" marginRight={1} color={'primary'} ref={ref}>
                            Total Cost and High-Cost Members Overview
                        </Typography>
                    </Grid>
                    <Grid size={12} display={'flex'}>
                        <Tabs sx={{ display: 'inline-flex', marginRight: 'auto' }} value={costSummaryTab} onChange={handleAlertsTabChange}>
                            <Tab value={1} label="Total Cost" />
                            <Tab value={2} label="Highest Cost Members" />
                        </Tabs>
                    </Grid>
                    <Grid size={12} marginTop={1} height="40vh" sx={{ position: 'relative' }}>
                        {costSummaryTab === 1 ? (
                            <TotalCost />
                        ) : (
                            <HighestCostMembers hasElevatedFilterAccess={true} />
                        )}
                    </Grid>
                </Grid>
            </Paper>
        </Grid>
    );
};

export default CostOverview;
